var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _c("base-table", {
        ref: "table",
        attrs: {
          loading: _vm.listLoading,
          "table-data": _vm.tableData,
          columns: _vm.tableColumns,
          showSelection: _vm.showSelection,
          "checked-list": _vm.checkedList,
          showPagination: false,
        },
        on: {
          "switch-change": _vm.onchangeIsShow,
          "selection-change": _vm.selectionChange,
        },
        scopedSlots: _vm._u(
          [
            _vm.showOperation
              ? {
                  key: "table-header",
                  fn: function () {
                    return [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: ["merchant:shipping:credits:package:add"],
                              expression:
                                "['merchant:shipping:credits:package:add']",
                            },
                          ],
                          staticClass: "mt20",
                          attrs: { size: "small", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.handleEdit(0)
                            },
                          },
                        },
                        [_vm._v(" 添加套餐 ")]
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "operate",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["merchant:shipping:credits:package:update"],
                          expression:
                            "['merchant:shipping:credits:package:update']",
                        },
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.handleEdit(1, row)
                        },
                      },
                    },
                    [_vm._v("编辑")]
                  ),
                  _c("el-divider", { attrs: { direction: "vertical" } }),
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["merchant:shipping:credits:package:delete"],
                          expression:
                            "['merchant:shipping:credits:package:delete']",
                        },
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.handleDelete(row.id)
                        },
                      },
                    },
                    [_vm._v("删除")]
                  ),
                ]
              },
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }